<style src="./InputSuggest.scss" lang="scss" scoped></style>
<template>
  <fieldset
    class="component">
    <label
      class="component--label"
      :class="{'valid-fail': false}">

      <div class="input-input--search-icon">
        <icon-search class="icon-search" />
      </div>

      <input ref="input"
        type="search"
        class="cp1-small-textbox input-input--typeahead-input"
        v-model="inputValue"
        :disabled="disabled"
        :placeholder="placeholder"
        :tabindex="tabIndex"
        autocomplete="off"
        v-debounce-directive="250"
        @focus="focusMe"
        @blur="validateBlur"
        @keydown.up="navigateUp"
        @keydown.down="navigateDown"
        @keydown.13="navigateChoose"
        @keydown.esc="closeSuggestion"
        @debounced="inputChanged">
    </label>

    <div
      class="input-input--searchbox-result">
      <div v-if="isSearching">
        <icon-wait
          v-show="isSearching"
          class="input-input--waiticon" />
        {{ searchingMessage }}
      </div>

      <div
        v-if="isNotFound && !escapeSearch"
        class="notfound">
        <slot name="notfound">
          <span class="message">
            {{ notfoundMessage }}
          </span>
        </slot>
      </div>

      <ul v-show="showSearch && !escapeSearch && !isNotFound">
        <slot />
      </ul>
    </div>
  </fieldset>
</template>

<script>
import { DebounceDirective } from '@/components/primitives/helpers/debounce/Debounce'
import { IconSearch, IconWait } from '@/components/primitives/icons'

export default {
  name: 'InputSuggest',
  components: {
    IconSearch,
    IconWait
  },
  directives: { debounceDirective: DebounceDirective },
  props: {
    label: {
      default: ''
    },
    tabIndex: {
      default: null
    },
    placeholder: {
      default: ''
    },
    disabled: {
      default: false
    },
    value: {
      default: null
    },
    min: {
      default: 0
    },
    searchingMessage: {
      default: 'Buscando...'
    },
    notfoundMessage: {
      default: 'Não encontramos nenhum resultado'
    }
  },
  data () {
    return {
      inputValue: '',
      escapeSearch: false
    }
  },
  watch: {
    value: {
      handler (pValue) {
        this.inputValue = pValue
      },
      immediate: true
    }
  },
  computed: {
    isSearching () {
      return this.$parent.isSearching
    },
    isNotFound () {
      return this.$parent.isNotFound
    },
    showSearch () {
      const showSearch = this.$parent.showSearch
      return showSearch
    },
    validValue () {
      return this.inputValue
    }
  },
  methods: {
    navigateUp () {
      this.escapeSearch = false
      const prevItem = this.$parent.selectedItemIdx - 1
      if (prevItem > -1) this.$parent.selectedItemIdx = prevItem
      this.scrollPositionAdjust()
    },
    navigateDown () {
      this.escapeSearch = false
      const nextItem = this.$parent.selectedItemIdx + 1
      if (this.$parent.suggestionList.length > nextItem) this.$parent.selectedItemIdx = nextItem
      this.scrollPositionAdjust()
    },
    navigateChoose (e) {
      const itemSelected = this.$parent.suggestionList[this.$parent.selectedItemIdx]
      if (!itemSelected) return false
      e.preventDefault()
      e.stopPropagation()

      this.$parent.selectingItemFromSuggestList(itemSelected)
      this.escapeSearch = true
    },
    closeSuggestion () {
      this.escapeSearch = true
      this.notfoundMessgae = false
    },
    focusMe () {
      this.escapeSearch = false
    },
    inputChanged (pValue) {
      if (this.inputValue === this.$parent.inputValue) return false
      this.$emit('input', this.inputValue)
      this.setScrollTopZero()
      if (this.inputValue && this.inputValue.length > this.min) {
        this.$parent.search(this.inputValue)
      } else {
        this.$parent.suggestionList = []
      }
    },
    getElementsToAdjustPosition () {
      const elementItem = this.$parent.$el.querySelectorAll('li')[this.$parent.selectedItemIdx]
      const elementContainer = this.$parent.$el.querySelectorAll('ul')[0]
      if (!elementItem || !elementContainer) return {elementItem: false}

      return {elementItem, elementContainer}
    },
    scrollPositionAdjust () {
      const {elementItem, elementContainer} = this.getElementsToAdjustPosition()
      if (!elementItem) return false
      const elementPositionTop = (elementItem.offsetTop + elementItem.offsetHeight)
      const containerHeight = elementContainer.offsetHeight
      const containerHeightDiff = containerHeight + elementContainer.scrollTop
      const marginBottom = (elementPositionTop + (elementItem.offsetHeight * 3))
      const elementTop = elementItem.offsetTop
      const containerScrollTop = elementContainer.scrollTop
      const marginTop = elementTop - (elementItem.offsetHeight * 3)

      if (marginBottom >= containerHeightDiff) {
        elementContainer.scrollTop = marginBottom - containerHeight
      }
      if (marginTop <= containerScrollTop) {
        elementContainer.scrollTop = marginTop
      }
    },
    setScrollTopZero () {
      const elementContainer = this.$parent.$el.querySelectorAll('ul')[0]
      elementContainer.scrollTop = 0
    },
    validateBlur () {
      this.$emit('blur')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-input-suggest/InputSuggest.vue